import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const CourseAdd = () => {
  const URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    courseTopicTh: "",
    courseTopicEn: "",
    maxSeat: "",
    objective: "",
    courseOutline: ["", "", "", "", ""], // Default 5 topics
    targetAudience: ["", "", ""], // Default 5 audiences
    learningFormat: "",
    traningDate: "",
    startTime: "",
    endTime: "",
    place: "",
    price: "",
    imageFile: "",
    startRegisterDate: "",
    endRegisterDate: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleTopicChange = (index, value) => {
    const updatedTopics = [...formData.courseOutline];
    updatedTopics[index] = value;
    setFormData({ ...formData, courseOutline: updatedTopics });
  };

  const handleAudienceChange = (index, value) => {
    const updatedAudiences = [...formData.targetAudience];
    updatedAudiences[index] = value;
    setFormData({ ...formData, targetAudience: updatedAudiences });
  };

  const addTopicInput = () => {
    setFormData({ ...formData, courseOutline: [...formData.courseOutline, ""] });
  };

  const addAudienceInput = () => {
    setFormData({ ...formData, targetAudience: [...formData.targetAudience, ""] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "courseOutline" || key === "targetAudience") {
        data.append(key, JSON.stringify(formData[key])); // Convert arrays to JSON strings
      } else {
        data.append(key, formData[key]);
      }
    });

    axios
      .post(`${URL}/courses`, data, {
        headers: { 
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      })
      .then((response) => {
        toast.success("บันทึกข้อมูลเรียบร้อยแล้ว");
        setTimeout(() => navigate("/panel/course"), 1000);
      })
      .catch((error) => {
        const data = error.response?.data;
        let msg = "บันทึกข้อมูลไม่สำเร็จ";

        if (data) {
          if (Array.isArray(data.errors)) {          
            msg = data.errors.map(e => e.msg).join(", ");
          } else if (data.message) {
            msg = data.message;
          }
        }

        toast.error(msg);
      });
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">การจัดการหลักสูตรอบม</h2>
      <hr></hr>   

      <nav className="flex mt-4 mb-8" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
          <li className="inline-flex items-center">
            <a href="/panel/course" className="inline-flex items-center font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
              <svg className="w-3 h-3 me-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z"/>
              </svg>
              หลักสูตรอบม
            </a>
          </li>
          <li aria-current="page">
            <div className="flex items-center">
              <svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
              </svg>
              <span className="ms-1 font-medium text-gray-500 md:ms-2 dark:text-gray-400">เพิ่มข้อมูล</span>
            </div>
          </li>
        </ol>
      </nav>


      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-2 font-medium">ชื่อช่องทาง (ภาษาไทย)</label>
          <input
            type="text"
            name="courseTopicTh"
            maxLength={100}            
            value={formData.courseTopicTh}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            placeholder="กรอกชื่อช่องทาง (ภาษาไทย)"
            required
          />
        </div>
        <div>
          <label className="block mb-2 font-medium">ชื่อช่องทาง (ภาษาอังกฤษ)</label>
          <input
            type="text"
            name="courseTopicEn"
            maxLength={100}
            value={formData.courseTopicEn}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            placeholder="กรอกชื่อช่องทาง (ภาษาอังกฤษ)"
            required
          />
        </div>
        <div>
          <label className="block mb-2 font-medium">จำนวนที่นั่งสูงสุด</label>
          <input
            type="number"
            name="maxSeat"
            min={0}
            max={1000}
            value={formData.maxSeat}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            placeholder="กรอกจำนวนที่นั่งสูงสุด"
            required
          />
        </div>
        <div>
          <label className="block mb-2 font-medium">วัตถุประสงค์</label>
          <textarea
            name="objective"
            maxLength={480}
            value={formData.objective}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            placeholder="กรอกวัตถุประสงค์"
            required
          />
        </div>


        <div>
          <label className="block mb-2 font-medium">หัวข้อการอบรม</label>
          {formData.courseOutline.map((topic, index) => (
            <div key={index} className="mb-2">
              <input
                type="text"
                maxLength={100}
                value={topic}
                onChange={(e) => handleTopicChange(index, e.target.value)}
                className="border border-gray-300 rounded px-4 py-2 w-full"
                placeholder={`หัวข้อที่ ${index + 1}`}
                required
              />
            </div>
          ))}
          <div className="flex space-x-4">
            
            <button
              onClick={addTopicInput}
              className="text-blue-500 hover:underline bg-transparent p-0 border-0"
              type="button"
            >
              เพิ่มหัวข้อ
            </button>
            {formData.courseOutline.length > 1 && (
              <button
                type="button"
                onClick={() => {
                  const updatedTopics = [...formData.courseOutline];
                  updatedTopics.pop(); // Remove the last topic
                  setFormData({ ...formData, courseOutline: updatedTopics });
                }}
                className="text-red-500 hover:underline"
              >
                ลบหัวข้อ
              </button>
            )}

          </div>
        </div>

        <div>
          <label className="block mb-2 font-medium">กลุ่มเป้าหมาย</label>
          {formData.targetAudience.map((audience, index) => (
            <div key={index} className="mb-2">
              <input
                type="text"
                maxLength={100}
                value={audience}
                onChange={(e) => handleAudienceChange(index, e.target.value)}
                className="border border-gray-300 rounded px-4 py-2 w-full"
                placeholder={`กลุ่มเป้าหมายที่ ${index + 1}`}
                required
              />
            </div>
          ))}
          <div className="flex space-x-4">
            
            <button
              onClick={addAudienceInput}
              className="text-blue-500 hover:underline bg-transparent p-0 border-0"
              type="button"
            >
              เพิ่มกลุ่ม
            </button>
            {formData.targetAudience.length > 1 && (
              <button
                type="button"
                onClick={() => {
                  const updatedAudiences = [...formData.targetAudience];
                  updatedAudiences.pop(); // Remove the last audience
                  setFormData({ ...formData, targetAudience: updatedAudiences });
                }}
                className="text-red-500 hover:underline bg-transparent p-0 border-0"
              >
                ลบกลุ่ม
              </button>
            )}

          </div>
        </div>

        <div>
          <label className="block mb-2 font-medium">รูปแบบการเรียนรู้</label>
          <select
            name="learningFormat"
            value={formData.learningFormat}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            required
          >
            <option value="">กรุณาเลือก</option>
            <option value="1">ออนไซต์</option>
            <option value="2">ออนไลน์</option>
            <option value="3">ออนไซต์และออนไลน์</option>
          </select>
        </div>
        <div>
          <label className="block mb-2 font-medium">วันที่เริ่มลงทะเบียน</label>
          <input
            type="date"
            name="startRegisterDate"
            value={formData.startRegisterDate}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            required
          />
        </div>
        <div>
          <label className="block mb-2 font-medium">วันที่สิ้นสุดลงทะเบียน</label>
          <input
            type="date"
            name="endRegisterDate"
            value={formData.endRegisterDate}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            required
          />
        </div>  
        <div>
          <label className="block mb-2 font-medium">วันที่อบรม</label>
          <input
            type="date"
            name="traningDate"
            value={formData.traningDate}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            required
          />
        </div>
        <div>
          <label className="block mb-2 font-medium">เวลาเริ่ม</label>
          <input
            type="time"
            name="startTime"
            value={formData.startTime}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            required
          />
        </div>
        <div>
          <label className="block mb-2 font-medium">เวลาสิ้นสุด</label>
          <input
            type="time"
            name="endTime"
            value={formData.endTime}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            required
          />
        </div>
      
        <div>
          <label className="block mb-2 font-medium">สถานที่</label>
          <input
            type="text"
            name="place"
            maxLength={100}
            value={formData.place}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            placeholder="กรอกสถานที่"
            required
          />
        </div>
        <div>
          <label className="block mb-2 font-medium">ราคา</label>
          <input
            type="number"
            name="price"
            min={0}
            max={1000000}
            value={formData.price}
            onChange={handleChange}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            placeholder="กรอกราคา"
            required
          />
        </div>
        <div>
          <label className="block mb-2 font-medium">ไฟล์รูปภาพ</label>
          <input
            type="file"
            name="imageFile"
            onChange={(e) => setFormData({ ...formData, imageFile: e.target.files[0] })}
            className="border border-gray-300 rounded px-4 py-2 w-full"
            accept="image/*"
            required
          />
        </div>
        <button
          type="submit"
          className="px-4 py-2 bg-blue-500 text-white rounded"
        >
          บันทึกข้อมูล
        </button>
      </form>
    </div>
  );
};

export default CourseAdd;